const contentStepsImages = document.querySelector(".content-steps-images");
const heroMatchMedia = gsap.matchMedia()

heroMatchMedia.add({
    isDesktop: "(min-width: 641px)",
    isMobile: "(max-width: 640px)",
}, (context) => {
    const { isDesktop, isMobile } = context.conditions;
    
    context.add("animateHero", () => {
        // updates background gradient and text color
        gsap.fromTo(".content-steps-wrapper", {
            "--custom-hero-color": "#FFFFFF",
            "--custom-hero-background-stop-1": "#323030",
            "--custom-hero-background-stop-2": "#050505",
        }, {
            scrollTrigger: {
                trigger: ".content-step.second-content",
                start: "top bottom",
                end: "top top",
                scrub: true
            },
            "--custom-hero-color": "#000000",
            "--custom-hero-background-stop-1": "#FFFFFF",
            "--custom-hero-background-stop-2": "#E4E4E4",
        })

        // updates images scale back on scroll
        gsap.fromTo(".content-steps-images .image-before,.content-steps-images .image-after", {
            transform: `scale(${isDesktop ? 1.5 : 3}) translate(0%, ${isDesktop ? 25. :12.5}%)`
        }, {
            scrollTrigger: {
                trigger: ".content-step.final-content",
                start: "top bottom",
                end: "top top",
                scrub: true
            },
            transform: "scale(1) translate(0%, 0%)"
        })

        // makes cursor appear while in view
        gsap.fromTo(".content-steps-images .comparison-cursor-wrapper,.content-step.final-content", {
            opacity: 0
        }, {
            scrollTrigger: {
                trigger: ".content-step.final-content",
                start: "top center",
                end: "top top-=25%",
                toggleActions: "play reverse play reverse",
                snap: [0.67],
                onEnter() {
                    contentStepsImages.style.pointerEvents = "auto"
                },
                onLeave() {
                    contentStepsImages.style.pointerEvents = "none"
                },
                onEnterBack() {
                    contentStepsImages.style.pointerEvents = "auto"
                },
                onLeaveBack() {
                    contentStepsImages.style.pointerEvents = "none"
                }
            },
            opacity: 1,
            duration: 0.3,
            ease: "power2.in"
        })

        // makes images disappear when portfolio grid enters the viewport
        gsap.fromTo(contentStepsImages, {
            opacity: 1
        }, {
            scrollTrigger: {
                trigger: ".portfolio-grid",
                start: "top bottom",
                end: "top top",
                scrub: true,
            },
            opacity: 0
        })

        // handles cursor
        Draggable.create(".comparison-cursor", {
            type: "x",
            trigger: ".cursor-handle",
            bounds: ".comparison-cursor-inner",
            onDrag(e) {
                contentStepsImages.style.setProperty("--cursor-position", `${this.pointerX}px`);
            }
        });
    });

    context.animateHero();
    document.addEventListener("shopify:section:load", context.animateHero);

    return () => {
        document.removeEventListener("shopify:section:load", context.animateHero)
    }
});